jQuery(function ($) {
  trusted_slider();
  model_tab();
  // faqs_accordion();
});

// trusted_slider js
function trusted_slider() {
  jQuery(".trusted_slider").owlCarousel({
    loop: true,
    autoplay: true,
    margin: 0,
    nav: false,
    autoplayTimeout: 3000,

    dots: false,
    responsive: {
      0: {
        items: 2,
      },

      700: {
        items: 3,
      },

      1100: {
        items: 4,
      },

      1366: {
        items: 5,
      },
    },
  });
}

// model tabbing functionally js
function model_tab() {
  jQuery(".model_section #tabs-nav li:first-child").addClass("active");
  jQuery(".model_section .tab-content").hide();
  jQuery(".model_section .tab-content:first").show();

  jQuery(".model_section #tabs-nav li").click(function () {
    jQuery(".model_section #tabs-nav li").removeClass("active");
    jQuery(this).addClass("active");
    jQuery(".model_section .tab-content").hide();

    let activeTab = jQuery(this).find("a").attr("href");
    jQuery(activeTab).fadeIn(800);
    return false;
  });
}

// FAQs accordion js start here
// function faqs_accordion() {
//   jQuery("#faq .accordian > div,#faq .accordian .accordion-item")
//     .slice(0, 8)
//     .show();
//   jQuery("#loadmore").on("click", function (e) {
//     e.preventDefault();
//     jQuery(
//       "#faq .accordian > div:hidden,#faq .accordian .accordion-item:hidden"
//     )
//       .slice(0, 8)
//       .slideDown();
//     if (
//       jQuery(
//         "#faq .accordian > div:hidden,#faq .accordian .accordion-item:hidden"
//       ).length == 0
//     ) {
//       jQuery("#loadmore").fadeOut("slow");
//     }
//   });

//   jQuery(".faq_section .accordion .accordion-item").slice(0, 8).show();
//   jQuery("#loadmore").on("click", function (e) {
//     e.preventDefault();
//     jQuery(".faq_section .accordion .accordion-item:hidden")
//       .slice(0, 8)
//       .slideDown();
//     if (jQuery(".faq_section .accordion .accordion-item:hidden").length == 0) {
//       jQuery("#loadmore").fadeOut("slow");
//     }
//   });
// }



// WEBPACK FOOTER //
// ./scripts/template3/script.js